import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
// Joins class names; when two Tailwind classes set the same thing, the later one wins.
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=utils.js.map